import React from 'react'
import { Container ,Col, Row, Button } from 'react-bootstrap'
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { BsArrowRightCircle } from 'react-icons/bs';

export default function IntroCoffee() {

    const data = useStaticQuery(graphql`
    query Coffee {
        file(relativePath: {eq: "coffee-white-bg.png"}) {
            childImageSharp {
                gatsbyImageData (
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                )
            }
        }
    } 
`);

const coffeeImage = getImage(data.file);

    return (
        <section className="py-5">
            <Container>
                <Row className="g-4">
                    <Col sm={11} md={6} lg={5}>
                        <GatsbyImage 
                            image={coffeeImage} 
                            alt="Coffee" 
                        />
                    </Col>
                    <Col sm={11} md={6} lg={5} xl={5} className="about-intro-info offset-md-1">
                        <h2 className="fs-2 mb-4 fw-bold make-serif topic"><span className="fw-light make-serif">About </span>Coffee</h2>
                        <p className="secondary-text small-text-02">Coffee beans are seeds of a Coffea plant, and the source for coffee. It is a pip inside the red or purple fruit often reffered to as a cherry.</p>
                        <p className="secondary-text small-text-02">Coffee is one of the world's most consumed beverages, and the coffee beans are a major cash crop, and important exports.</p>
                        <AnchorLink to="/nuts#intro">
                            <Button 
                                className="main-gradient border-none mt-3"
                                size="md"
                            >
                                <BsArrowRightCircle size="1.4rem" className="me-2 white-text"/>
                                <span className="white-text">Oilseed Nuts</span>
                            </Button>
                        </AnchorLink>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
